import { render, staticRenderFns } from "./ReceivedGoods.vue?vue&type=template&id=7ca539cf"
import script from "./ReceivedGoods.vue?vue&type=script&lang=js"
export * from "./ReceivedGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports